import { render, staticRenderFns } from "./gb-ant-input-textarea-limit.vue?vue&type=template&id=6350158c&scoped=true&"
import script from "./gb-ant-input-textarea-limit.vue?vue&type=script&lang=js&"
export * from "./gb-ant-input-textarea-limit.vue?vue&type=script&lang=js&"
import style0 from "./gb-ant-input-textarea-limit.vue?vue&type=style&index=0&lang=less&"
import style1 from "./gb-ant-input-textarea-limit.vue?vue&type=style&index=1&id=6350158c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6350158c",
  null
  
)

export default component.exports